import {
    FrontendFilter,
    FrontendFilterBatchAction,
    FrontendFilterGroup,
    FrontendFilterResultColumn,
    FrontendFilterResultRowModifier,
    FrontendFilterResultRowModifierCssClasses, FrontendFilterValues
} from "@/components/FrontendFilters/structs";
import Vue from "vue";

export class FrontendFiltersTriggers implements FrontendFilterGroup {
    identifier = 'triggers';
    subIdentifier = 'default';

    pageIcon = '';
    pageTitleLanguageKey = 'omt.gui.triggers.page-title';

    resultsPerPage = 100;
    searchApiDefaultParameters = {
        include: 'conditions,actions'
    }
    searchApiPath = '/api/triggers';

    resultRowModifiers = [
        () => new FrontendFilterResultRowModifier(
            () => true,
            FrontendFilterResultRowModifierCssClasses.striped,
        ),
    ];

    getResultLink(result: Record<string,string>, filterValues: FrontendFilterValues): Record<string,any> {
        return {};
    }

    batchActions = [];

    filters = [

    ];

    columns = [
        new FrontendFilterResultColumn(
            'id',
            (resultRow) => resultRow.id,
        ),
        new FrontendFilterResultColumn(
            'event_class',
            (resultRow) => resultRow.event_class.split('\\').pop()
        ),
        new FrontendFilterResultColumn(
            'description',
            (resultRow) => Vue.component('TriggerDescription', () => import('@/views/Triggers/FrontendFilterEventResultColumnValues/TriggerDescription.vue') as object),
        ),
        new FrontendFilterResultColumn(
            'conditions',
            // @ts-ignore
            () => Vue.component('TriggerConditionsView', () => import('@/views/Triggers/FrontendFilterEventResultColumnValues/TriggerConditionsView.vue') as object)
        ),
        new FrontendFilterResultColumn(
            'actions',
            // @ts-ignore
            () => Vue.component('TriggerActionsView', () => import('@/views/Triggers/FrontendFilterEventResultColumnValues/TriggerActionsView.vue') as object)
        ),
    ];

}
